import axios from 'axios';

const api = axios.create({
    baseURL: '/api',
});

api.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
api.defaults.headers.common['X-Locale'] = document.querySelector('meta[name="locale"]')?.content;

export default api;
